/**
 * Whether finishing a cycle's steps may be celebrated.
 *
 * The hub's completion banner fires on step progress alone, which says nothing
 * about how the cycle went. That was harmless while the banner replaced the
 * whole card and was walked past once; it is not harmless now that it sits above
 * a tab strip she keeps using, where it can outlive the news.
 *
 * Tone is decided by the ending, never by the surface — the same rule
 * `RecordedResultView` follows. Only a recorded pregnancy is celebrated. No
 * ending yet still celebrates: there is nothing there to be insensitive about.
 */
export function completionMayBeCelebrated(
  outcome: { type?: string | null } | null | undefined,
): boolean {
  if (!outcome?.type) return true;
  return outcome.type === "pregnancy";
}
